import { Button, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({}));

export function useGrades() {
  const [grades, setGrades] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/grades')
      .then((response) => response.json())
      .then((data) => {
        setGrades(data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { grades, setGrades };
}

export default function Grades() {
  const { grades, setGrades } = useGrades();
  const [name, setName] = React.useState('');
  const [number, setNumber] = React.useState('');
  const [selectedGrade, setSelectedGrade] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/grades-update/${id}`);
  };

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
    },
    {
      name: 'number',
      label: 'Numero',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(grades[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los glosarios seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/grades/${
            grades[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
        if (data.success) {
          setGrades(grades.splice(row?.dataIndex, 1));
        }
      });
    }
  };

  useEffect(() => {
    if (selectedGrade) {
      setName(selectedGrade?.name);
      setNumber(selectedGrade?.number);
    }
  }, [selectedGrade]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        grados creados en la plataforma, desde esta sección podrá gestionar cada
        una de ellas, ten mucha precaución de eliminar algún grado, si ya cuenta
        con asociaciones, este proceso no se puede recuperar.
      </p>
      <MUIDataTable
        title={'Listado de asignaturas'}
        data={grades}
        columns={columns}
        options={{
          onRowsDelete: (rowsDeleted) => {
            handleDelete(rowsDeleted);
          },
        }}
      />
    </div>
  );
}
